import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';
import DOMPurify from 'dompurify';

// Components
import * as icons from '../Icons/Icons';
import Pricing from './Pricing';
import Payments from '../Payments/Payments';
import StartVTC from './StartVTC';

const ScheduleVTC = observer(class ScheduleVTC extends React.Component {
  constructor() {
    super();
    this.setFees = this.setFees.bind(this);
    this.renderPricingButton = this.renderPricingButton.bind(this);
    this.submitSchedule = this.submitSchedule.bind(this);
    this.showConfirmation = this.showConfirmation.bind(this);
  }

  componentWillMount() {
    const { PaymentStore, ProctorStore } = this.props.store;

    this.state = {
      fees: null,
      voucherCode: null,
      accessCode: null,
      initialFee: null
    }

    if(this.props.status.toLowerCase() !== 'scheduled') {
      this.setState({
        step: 1
      });
    } else {
      this.setState({
        step: 4
      });
    }

    if(this.props.accessCode) {
      this.setState({
        accessCode: this.props.accessCode
      });
    }

    // Set payment callback
    PaymentStore.setAfterPayment((event) => this.nextStep(event));

    // Get the pricing data
    const _this = this;
    setTimeout(function(){
      const query = `?proctorLocationSids=${_this.props.proctorLocationSid}&examSessionSid=${_this.props.sessionSid}`;

      ProctorStore.searchProctors(query, _this.setFees, null);
    });

    this.props.store.SessionStore.getCurrentTime();
  }

  setFees(i, data) {
    this.setState({
      fees: data[0].fees,
      initialFees: data[0].fees.userTotal
    });
  }

  setStep(e, step) {
    if(e) {
      e.preventDefault();
    }

    this.setState({
      step
    }, function(){
      // Hide the close button on the last step so the
      // student has to click the return to dashboard button
      if(this.state.step === 4) {
        this.props.store.SessionStore.hideDrawerClose = true;
      }
    });
  }

  nextStep(e) {
    if(e) {
      e.preventDefault();
    }

    this.setState({
      step: this.state.step + 1
    });
  }

  prevStep() {
    this.setState({
      step: this.state.step - 1
    });
  }

  isActive(step) {
    if(this.state.step === step) {
      return true;
    } else {
      return false;
    }
  }

  statusClass(step) {
    if(this.state.step === step) {
      return 'slide-active';
    } else if(this.state.step > step) {
      return 'slide-hidden-before';
    } else {
      return 'slide-hidden-after';
    }
  }

  renderPricingButton() {
    const { translation } = this.props;

    if(this.state.fees) {
      if(this.state.fees.userTotal > 0) {
        return (
          <button
            className="btn"
            onClick={(e) => {this.nextStep(e)}}
          >
            {translation.next}
          </button>
        )
      }

      if(this.state.fees.userTotal === 0) {
        return (
          <button
            className="btn"
            onClick={this.submitSchedule}
          >
            {translation.schedule}
          </button>
        )
      }
    }

    return null;
  }

  submitSchedule() {
    const { ExamStore, ScheduleStore } = this.props.store;
    const { duration } = ExamStore.examSession.examConfiguration;

    const data = {
      amount: this.state.fees.userTotal,
      currency: this.state.fees.currencyCode,
      type: 'vtc',
      appointmentDateTime: moment(ExamStore.examSession.examConfiguration.examCloseDate).subtract(duration, 'minutes').subtract(1, 'hours').toISOString(),
      proctorLocationSid: this.props.proctorLocationSid
    }

    ScheduleStore.createAppointment(this.props.examSid, this.props.sessionSid, data, this.showConfirmation);
  }

  showConfirmation(response) {
    this.setStep(null, 4);

    this.setState({
      accessCode: response.data.accessKey
    });
  }

  render() {
    const { translation } = this.props;
    const { ExamStore, SessionStore } = this.props.store;

    let examOpen = true;

    const now = moment(this.props.store.SessionStore.currentTime);
    const openDate = moment(ExamStore.examSession.examConfiguration.examOpenDate);
    const openDiff = moment.duration(openDate.diff(now)).asHours();

    if(openDiff >= 0) {
      examOpen = false;
    }

    if(!SessionStore.backgroundLoading) {
      return (
        <div className="drawer__content">
          <header className="drawer__header">
            <div className="wrap">
              <h1 className="drawer__title">{translation.heading}</h1>
            </div>
          </header>
          <div className="slide-wrap slide-wrap--sticky wrap">
            <div className={`panel panel--medium ${this.statusClass(1)}`}>
              <h1 className="panel__title--alt">{translation.title}</h1>

              <div
                className="schedule-intro"
                dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(translation.body)}}
              />

              <div className="text-block">
                <h5><strong>{translation.requirements.heading}</strong></h5>


                <ul>
                  {translation.requirements.requirement_list.map(
                      (requirement, i) =>
                          <li key={i}>{requirement}</li>
                  )}
                  <li
                    dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(translation.requirements.headphone_note)}}
                  />
                  <li>
                    {translation.requirements.system_check}<a href="https://system-test.smarterproctoring.com/" target="_blank">{translation.system_check_link}</a>
                  </li>
                  <li
                      dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(translation.requirements.cellphone_note)}}
                  />
                </ul>
                <p>
                  <strong>
                    {translation.record_reminder}
                  </strong>
                </p>
              </div>

              <div className="note">
                <p>
                  <strong>{translation.cost_heading}</strong>
                </p>
                <p>${this.state.initialFees}</p>
                <p>{translation.cost_info}</p>
              </div>

              <button
                  className="btn"
                  onClick={(e) => {this.nextStep(e)}}
              >
                <icons.iconCalendarPlus />
                {translation.requirements.button}
              </button>
            </div>

            <div className={`panel panel--brief ${this.statusClass(2)}`}>
              <Pricing fees={this.state.fees} scheduler={this} {...this.props} />

              {this.renderPricingButton()}

              <span className="preposition--vertical">{translation.pricing.or}</span>

              <button
                  className="btn--link"
                  onClick={(e) => {this.prevStep(e)}}
              >
                {translation.go_back}
              </button>
            </div>

            <div className={`panel panel--brief ${this.statusClass(3)}`}>
              <h2 className="panel__title">{translation.payment.heading}</h2>

              <Payments submit={this.submitSchedule} {...this.props} />
            </div>

            <div className={`panel panel--brief ${this.statusClass(4)}`}>
              <h2 className="panel__title">{translation.confirmed.heading}</h2>

              {examOpen &&
              <div>
                <p>{translation.confirmed.body_open}</p>

                <div className="actions panel__actions">
                  <button
                      className="btn actions__btn"
                      onClick={(e) => this.nextStep(e)}
                  >
                    {translation.confirmed.start_now}
                  </button>

                  <Link
                      className="btn btn--outline actions__btn"
                      to="/"
                      onClick={() => {SessionStore.hideDrawerClose = false}}
                  >
                    {translation.confirmed.start_later}
                  </Link>
                </div>
              </div>
              }

              {!examOpen &&
              <div>
                <p>{translation.confirmed.body_closed}</p>

                <Link
                    className="btn--link"
                    to="/"
                    onClick={() => {SessionStore.hideDrawerClose = false}}
                >
                  {translation.confirmed.dashboard}
                </Link>
              </div>
              }

              <Link
                  className="btn--link"
                  to="/"
                  onClick={() => {SessionStore.hideDrawerClose = false}}
              >
                {translation.confirmed.button}
              </Link>
            </div>

            <div className={this.statusClass(5)}>
              {this.state.step === 5 &&
              <StartVTC
                  {...this.props}
                  accessCode={ExamStore.examSession.accessKey}
              />
              }
            </div>
          </div>
        </div>
      );
    }

    return null;
  }
})

export default translate('ScheduleVTC')(ScheduleVTC);



// WEBPACK FOOTER //
// ./src/app/components/StudentDashboard/ScheduleVTC.js